import React from "react";
import { Button, Modal, ModalHeader, ModalBody, ModalFooter } from "reactstrap";

const ModalCustom = (props) => {
  //
  const {
    title,
    children,
    openPopup,
    setOpenPopup,
    size,
    isHeaderCloseBtn,
    ...rest
  } = props;
  const customClass = props.customClass || " ";
  const isCloseBtnShow = isHeaderCloseBtn == false ? false : true;
  //
  return (
    <>
      <Modal
      backdrop="static"
        isOpen={openPopup}
        toggle={() => {
          setOpenPopup(false);
        }}
        onClosed={() => {
          setOpenPopup(false);
        }}
        size={size}
        {...rest}
      >
        <ModalHeader
          toggle={
            isCloseBtnShow
              ? () => {
                  setOpenPopup(false);
                }
              : ""
          }
        
        >
          {title}
        </ModalHeader>
        <ModalBody className={`fs--1 font-weight-normal ${customClass}`}>
          {children}
        </ModalBody>
        {/* <ModalFooter>
            <Button color="secondary" onClick={()=>{setOpenPopup(false)}}>Cancel</Button>
            <Button color="primary" >Submit</Button>
          </ModalFooter> */}
      </Modal>
    </>
  );
};

export default ModalCustom;
